module.exports = __webpack_public_path__ + "static/media/timer-backing.f680b46c.png";